import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Page from '../../layout/components/Page';
import pagenotfount from '../../assets/images/page-not-found.svg';

const title = '';

function Error404() {
  const location = useLocation();
  const url = location.pathname.includes('aisle') ? '/aisle/market-stream' : '/growz/overview';

  return (
    <Page title={title} heading={title}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          alignContent: 'center',
          margin: '10em 0',
        }}
      >
        <img src={pagenotfount} style={{ width: '230px' }} />
        <p style={{ fontWeight: '500', fontSize: '18px', textAlign: 'center', lineHeight: '28px', margin: '2em 0 2em 0' }}>
          Maybe the page you are looking for has been removed or <br />
          you typed in the wrong URL
        </p>
        <div className="card-action">
          <Link
            className="waves-effect waves-green"
            to={url}
            style={{ color: 'initial', fontWeight: '500', textDecoration: 'underline' }}
          >
            Go to Dashboard
          </Link>
        </div>
      </div>
    </Page>
  );
}

export default Error404;
